import React from "react";
import { styled } from "../../../stitches.config";
import Html from "./Html";

export default class Slideshow extends React.Component {

  renderSlide(slide) {
    const picture = slide.picture
    return (
      <div>
        <SlideTitle className="parts-slideshow__slide-title">
          {slide.title}
        </SlideTitle>
        <SlideImg>
          <img src={slide.picture.img} />
          <ImgAuthor>
            {picture.figcaption}
            {picture.source ? ' / ' + picture.source : null}
          </ImgAuthor>
        </SlideImg>
        <SlideBody className="parts-slideshow__slide-body">
          <Html html={slide.body} />
        </SlideBody>
      </div>
    );
  }

  render() {
    const slides = this.props.slides;

    return (
      <div>
        {slides.map((slide) => { return this.renderSlide(slide) })}
      </div>
    );
  }
}

const SlideTitle = styled("div", {
  fontSize: "32px",
  lineHeight: "40px",
  letterSpacing: "0.3px",
  fontWeight: 700,
  color: "$grayscale100",
  padding: "5px",
  margin: "35px 0 0 0",
  hyphens: "auto",
  "@bp4": {
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "0.3px",
    padding: "10px 0"
  }
});

const SlideImg = styled("div", {
  width: "100%",
  position: "relative",
  "@bp4": {
    maxWidth: "840px"
  },
  "img": {
    width: "100%"
  },
  "span": {
    position: "relative",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    fontSize: "14px",
    padding: "8px 0px 0px",
    lineHeight: "18px",
    color: "rgb(141, 141, 141)",
    fontWeight: 600
  }
});

const ImgAuthor = styled("div", {
  position: "absolute",
  fontSize: "11px",
  color: "#8B8B8B",
  "@bp4": {
    fontSize: "13px"
  }
});

const SlideBody = styled("div", {
  padding: "5px 10px 10px",
  borderLeft: "1px solid rgba(151,151,151,0.15)",
  borderBottom: "1px solid rgba(151,151,151,0.15)",
  position: "relative",
  fontWeight: "lighter",
  "div":{
    color: "$grayscale100 !important"
  },
  "a": {
    color: "$primary"
  },
  "@bp4": {
    padding: "10px 20px 20px"
  },
  "span": {
    bottom: "-18px",
    left: "9px"
  }
});